"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class TrialsConfigurationSamplesService {
    constructor(obj) {
        this.allSamples = [];
        this.isLoadingSamples = false;
        this.isEditing = true;
        this.proposalID = obj.proposalId;
        this.projectID = obj.projectId;
    }
    async assignSamples(payload) {
        this.isEditing = true;
        try {
            const response = await axios_1.default.post(`/data/tracking/trials/${this.proposalID}/project/${this.projectID}/samples`, payload);
            this.isEditing = false;
            return response;
        }
        catch (error) {
            this.isEditing = false;
            //@ts-ignore
            return Promise.reject(error.response);
        }
    }
    async markSampleAsSent(payload) {
        this.isEditing = true;
        try {
            const response = await axios_1.default.post(`/data/tracking/trials/${this.proposalID}/project/${this.projectID}/samples/mark_sent`, payload);
            this.isEditing = false;
            return response;
        }
        catch (error) {
            this.isEditing = false;
            //@ts-ignore
            return Promise.reject(error.response);
        }
    }
    async setDateToSampleGroup(payload) {
        this.isEditing = true;
        try {
            const response = await axios_1.default.post(`/data/tracking/trials/${this.proposalID}/project/${this.projectID}/samplegroup/setdate`, payload);
            this.isEditing = false;
            return response;
        }
        catch (error) {
            this.isEditing = false;
            //@ts-ignore
            return Promise.reject(error.response);
        }
    }
    async getAssignedSamples(payload) {
        this.isEditing = true;
        let query = {};
        if (payload.time)
            query = Object.assign(Object.assign({}, query), { time: payload.time });
        if (payload.location_id)
            query = Object.assign(Object.assign({}, query), { location_id: payload.location_id });
        if (payload.treatment_id)
            query = Object.assign(Object.assign({}, query), { treatment_id: payload.treatment_id });
        try {
            const response = await axios_1.default.get(`/data/tracking/trials/${this.proposalID}/project/${this.projectID}/assigned_samples`, { params: payload });
            return response;
        }
        catch (error) {
            console.log(error);
        }
        this.isEditing = false;
    }
    get isLoading() {
        return this.isEditing;
    }
    get collectAllSamples() {
        return this.allSamples;
    }
}
exports.default = TrialsConfigurationSamplesService;
